import { useEffect, useRef, useState } from "react";
import { copyToClipboard } from "src/utils/copyToClipboard";

interface IUseCopyToClipboardOptions {
  resetAfterMs?: number;
}

export default function useCopyToClipboard(
  options: IUseCopyToClipboardOptions = {},
) {
  const { resetAfterMs = 2000 } = options;
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(
    () => () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    },
    [],
  );

  const handleCopy = async (text: string) => {
    const success = await copyToClipboard(text);
    if (!success) return false;

    setCopied(true);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setCopied(false), resetAfterMs);
    return true;
  };

  return { copied, handleCopy };
}
